import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter, ViewChild, ElementRef, AfterContentInit, AfterViewInit } from '@angular/core';
import _ from 'lodash';
import { APIServiceProviderService } from '../services/APIServices/APIServiceProviderService/APIServiceProviderService';
import * as globalVariable from '../../shared/globalcontants';
import { CommonService } from '../services/common.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { GlobalConversionService } from '../services/GlobalMethodService/GlobalConversion-Service';
import { NgClass } from '@angular/common';
import { ViewmoreDirective } from '../directives/view-more.directive';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TrimLower } from '../pipes/trim-lower-str.pipe';

@Component({
    selector: 'app-item-details',
    templateUrl: './item-details.component.html',
    styleUrls: ['./item-details.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, ViewmoreDirective, MatFormField, MatLabel, MatInput, ReactiveFormsModule, FormsModule, TranslateModule, TrimLower]
})
export class ItemDetailsComponent implements OnInit, AfterContentInit, AfterViewInit {
  @ViewChild('sampleDiv') el: ElementRef;
  @Input() itemInputs: any;
  itemBodyDetails: any;
  itemHeaderDetails: any;
  baseUnit: string;
  icons: any;
  config: any;
  @Output() RemarkChanged: EventEmitter<any> = new EventEmitter();

  constructor(private apiServiceProviderService: APIServiceProviderService, public _cs: CommonService, private _ts: TranslateService,public globalConversionService : GlobalConversionService) { }


  ngOnInit() {
  }

  ngAfterContentInit() {
    this.itemBodyDetails = this.itemInputs.itemBodyData;
    this.itemHeaderDetails = this.itemInputs.itemHeaderData;
    this.baseUnit = this.itemInputs.baseUnit ? this.itemInputs.baseUnit : '';
    this.icons = this.itemInputs.hasOwnProperty('icons') ? this.itemInputs.icons : [];
  }

  ngAfterViewInit() {
    this.config = {
      'text': this.el ? this.el.nativeElement.innerText : '',
      'numberoflines': 3,
      'showMoreFont': globalVariable.readMore.fontSize,
      'showMoreText': this._ts.instant('common.readMore'),
      'showLessText': this._ts.instant('common.readLess'),
      'showMoreColor': globalVariable.readMore.fontColor,
      'textFontSize': '14px',
      'textFontFamily': globalVariable.readMore.fontFamily
    };
  }

  hasBaseUnit = (jsonkey) => {
    return jsonkey === 'QuantityonHandForAllLocs' || jsonkey === 'IngMinParForAllLocs' || jsonkey === 'IngMaxParForAllLocs';
  }

  totalItemsLength = () => {
    return this.itemHeaderDetails.length % 2 === 0 ? 'even' : 'odd';
  }

  remarksChanged(remark, data) {
    this.RemarkChanged.emit(data);
  }
}
